module.exports = __webpack_public_path__ + "static/media/bulb.b7084a91.png";